import React from 'react';
import { Lead } from '@dnb/eufemia/elements';
import { P } from '@dnb/eufemia/elements';
import styles from './ApplicationRequirementItem.module.scss';

export interface Props {
  title: React.ReactNode;
  message: React.ReactNode;
  icon: React.ReactNode;
}

const ApplicationRequirementItem = ({ title, message, icon }: Props) => {
  return (
    <li data-testid="odd-application-requirement" className={styles.container}>
      {icon}
      <div>
        <Lead bottom="x-small">{title}</Lead>
        <P>{message}</P>
      </div>
    </li>
  );
};

export default ApplicationRequirementItem;
